module.exports = __webpack_public_path__ + "img/icon-close.cdb1b40b.svg";